import { createAction } from '../../../../store.model';
import { ActionType } from '../task-list-dialog.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reload {}

export const reload = createAction<ActionType, Reload>(
    ActionType.TC__TL__RELOAD,
);
